
Librarian.ImageSelectWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["addImages", "selectImage", "upload", "select"],

    options: {
        id: "ImageSelectWindow",
        width: 800,
        height: 435,
        resizable: false,
        params: {
            subtype: null,
            tmpl: false,
            all: false  // IncludeShared
        }
    },

    onSuccess: null,
    uploadWindow: null,
    selectedImag: null,

    initialize: function(options) {
        this.setOptions(options);

        this.onSuccess = options.onSuccess;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("eventgroup_selectimage");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/imageselect.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("uploadButton");
        if (itemEl) {
            itemEl.show();
            itemEl.addOnClick(this.upload, this);
        }

        itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("selectButton");
        if (itemEl)
            itemEl.addOnClick(this.select, this);

        this.getImages();
    },

    getImages: function() {
        var url = Librarian.path.getSupportUrl("getfis") + "&out=cjson&ftype=" + Librarian.SupportFiles.supportFileTypes.image;
        new Librarian.Request.JSON({
            url: url,
            data: this.options.params,
            onSuccess: this.addImages
        }).send();
    },

    addImages: function(images) {
        var self = this,
            list = this.getElement("imageList");

        if (list) {
            list.empty();
            images.forEach(function(image) {
                var imageEl = new Element("div", {
                    "class": "imageSelect-imageItem ellipsis",
                    "title": image.name,
                    "text": image.name
                }).inject(list);

                imageEl.data = image;
                imageEl.addOnClick(function() {
                    self.selectImage(this);
                });
            });
        }
    },

    selectImage: function(imageEl) {
        imageEl.select();

        this.selectedImage = imageEl.data;
        var previewEl = this.getElement("previewImage");

        if (previewEl)
            previewEl.src = Librarian.path.getDownloadUrl("dsf") + "&fh=" + this.selectedImage.hash;
    },

    upload: function() {
        this.uploadWindow = new Librarian.FileUploadWindow({
            uploadUrl: Librarian.path.getSupportUrl("uplfile") + "&ftype=" + Librarian.SupportFiles.supportFileTypes.image + '&' + Object.toQueryString(this.options.params),
            acceptType: "image/*",
            onSuccess: function() {
                this.getImages();
            }.bind(this)
        });
    },

    select: function() {
        this.close();

        if (this.selectedImage && typeof this.onSuccess == "function")
            this.onSuccess(this.selectedImage);
    },

    onClose: function() {
        if (this.uploadWindow)
            this.uploadWindow.close();
    }
});
